module.exports = __webpack_public_path__ + "static/21-thumb-aab7692fdd0f3aced2e496722e832721.jpg";